import React, { useContext, useState } from "react";
import {
  Button,
  Label,
  Table,
  Menu,
  Icon,
  Container,
  Confirm,
} from "semantic-ui-react";
import CustomerStore from "../../../app/stores/customerStore";
import { Link } from "react-router-dom";
import { observer } from "mobx-react-lite";
const CustomerList: React.FC = () => {
  const [open, setOpen] = useState(false);
  const [customerId, setCustomerId] = useState("");
  const customerStore = useContext(CustomerStore);
  const {
    customersByName: customersByName,
    deleteCustomer: deleteCustomer,
    submitting,
    target,
  } = customerStore;

  return (
    <Container>
      <Table singleLine>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Name</Table.HeaderCell>
            <Table.HeaderCell>ABN</Table.HeaderCell>
            <Table.HeaderCell>Address</Table.HeaderCell>
            <Table.HeaderCell>Contact Name</Table.HeaderCell>
            <Table.HeaderCell>Email</Table.HeaderCell>
            <Table.HeaderCell>Phone</Table.HeaderCell>
            <Table.HeaderCell>Remark</Table.HeaderCell>
            <Table.HeaderCell width={1}>Action</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {customersByName.map((customer) => (
            <Table.Row key={customer.id}>
              <Table.Cell>
                <Label>{customer.name}</Label>
              </Table.Cell>
              <Table.Cell>{customer.abn}</Table.Cell>
              <Table.Cell>{customer.address}</Table.Cell>
              <Table.Cell>{customer.contactName}</Table.Cell>
              <Table.Cell>{customer.email}</Table.Cell>
              <Table.Cell>{customer.phone}</Table.Cell>
              <Table.Cell>{customer.remark}</Table.Cell>
              <Table.Cell>
                <Button.Group size="mini">
                  <Button
                    as={Link}
                    to={`/dailymanagement/customer/${customer.id}`}
                    size="mini"
                    icon="zoom in"
                    color="blue"
                    title="View"
                  />
                  <Button
                    name={customer.id}
                    size="mini"
                    loading={target === customer.id && submitting}
                    onClick={() => {
                      setOpen(true);
                      setCustomerId(customer.id);
                    }}
                    icon="delete"
                    color="red"
                    title="Delete"
                  />
                  <Confirm
                    open={open}
                    onCancel={() => setOpen(false)}
                    onConfirm={(e) => {
                      deleteCustomer(customerId);
                      setOpen(false);
                    }}
                    content="Are you sure you want to delete ?"
                    confirmButton="Yes"
                    size="mini"
                    style={{
                      position: "relative",
                      maxHeight: "150px",
                      height: "auto",
                    }}
                  />
                </Button.Group>
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    </Container>
  );
};

export default observer(CustomerList);
